import { compact, map } from 'lodash';
import { epoch, utc } from '../../util/datetime';
import { formatAsBytes, toUUID } from '../../util/transform';
import { DocType } from '../global/Doc.enum';
import Root from '../Root';
import type { IExport } from './Export.interface';
import ExportAccessHistory from './ExportAccessHistory';

export default class Export extends Root implements IExport {
  idAccount: string;
  accountInformation: string;
  accessHistory: Array<ExportAccessHistory>;
  file: string;
  size: number;
  completedTimeStamp: number;

  getSize = () => {
    return formatAsBytes(this.size);
  };

  static build = (data: IExport) => new Export(data);
  static blank = () => new Export();

  /**
   * Constructor
   * @param {IExport} data
   */
  constructor(data?: IExport) {
    super(DocType.of('__operation.export'), data);

    this.idAccount = toUUID(data?.idAccount);
    this.accountInformation = data.accountInformation;
    this.accessHistory = compact(
      map(data?.accessHistory, (obj) => new ExportAccessHistory(obj))
    );
    this.file = data?.file || '';
    this.size = data?.size || 0;
    this.completedTimeStamp = epoch(utc(data?.completedTimeStamp));
  }
}
